import React from "react";
import styled from "styled-components";
import { Link } from "react-scroll";
import baseStyles from "../../styles/baseStyles";

const List = styled.ul`
  padding: 0;
  margin: 0;
  flex: 0 0 40%;
  align-self: flex-start;
  position: sticky;
  top: 6rem;
`;
const Category = styled.ul`
  padding: 0;
`;

const CategoryTitle = styled(Link)`
  font-family: Futura;
  color: rgba(37, 42, 43, 0.75);
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
  transition: 0.2s all ease;
  cursor: pointer;
  :hover {
    color: ${baseStyles.color.primary};
  }
  &.active {
    color: ${baseStyles.color.primary};
  }
`;

const ArticleList = styled.ul`
  margin: 0.75rem 0;
  padding: 0;
  list-style: none;
`;

const Article = styled.li`
  cursor: pointer;
  margin: 0.15rem 0;
`;

const ArticleTitle = styled(Link)`
  font-family: Lato;
  font-size: 15px;
  color: rgba(37, 42, 43, 0.75);
  letter-spacing: 1.33px;
  border-left: 3px solid transparent;
  transition: 0.2s all ease;
  :hover {
    color: ${baseStyles.color.primary};
  }
  &.active {
    color: ${baseStyles.color.primary};
  }
`;

const SideNavigation = ({ contentCategories }) => {
  const showArticles = articles =>
    articles.map(({ title }) => (
      <Article key={title}>
        <ArticleTitle
          activeClass="active"
          to={title}
          spy={true}
          smooth={true}
          offset={-64}
          duration={500}
        >
          {title}
        </ArticleTitle>
      </Article>
    ));
  return (
    <List>
      {contentCategories
        ? contentCategories.map(({ title, articles }) => (
            <Category key={title}>
              <CategoryTitle
                activeClass="active"
                to={title}
                spy={true}
                smooth={true}
                offset={-64}
                duration={500}
              >
                {title}
              </CategoryTitle>
              <ArticleList>{showArticles(articles)}</ArticleList>
            </Category>
          ))
        : null}
    </List>
  );
};

export default SideNavigation;



// WEBPACK FOOTER //
// ./src/components/UI/SideNavigation.js